import {
  GridCol,
  Grid,
  Text,
  MantineSize,
  Box,
  Group,
  TextInputProps,
  GridProps,
} from "@mantine/core"

import { TextInput } from "../TextInput/TextInput"

type Props = {
  value?: string | null
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
  size?: MantineSize
  cta?: React.ReactNode
  textInputProps?: TextInputProps
}

export function InlineTextInput({
  value,
  onChange,
  label,
  size = "xs",
  cta,
  textInputProps,
  ...props
}: Props & GridProps) {
  return (
    <Grid px="var(--mantine-spacing-xs)" align="center" {...props}>
      {label && (
        <GridCol span="content">
          <Text fw={600} fz={size}>
            {label}
          </Text>
        </GridCol>
      )}
      <GridCol span="auto">
        <Group wrap="nowrap" gap="var(--mantine-spacing-xs)" w="100%">
          <TextInput
            value={value ?? undefined}
            size={size}
            w="100%"
            onChange={onChange}
            {...textInputProps}
          />
          <Box ml="xs">{cta}</Box>
        </Group>
      </GridCol>
    </Grid>
  )
}
